export interface Mixture {
  id: number
  name: string
  sheet_id_de: number
  sheet_id_en: number
  butane: number
  isobutane: number
  propane: number
  bar: number
}

export const mixtures: Mixture[] = [
  {
    id: 1,
    name: '12',
    sheet_id_de: 4574,
    sheet_id_en: 4599,
    butane: 100.0,
    isobutane: 0.0,
    propane: 0.0,
    bar: 1.2
  },
  {
    id: 2,
    name: '14C',
    sheet_id_de: 5501,
    sheet_id_en: 5562,
    butane: 77.8,
    isobutane: 22.2,
    propane: 0.0,
    bar: 1.4
  },
  {
    id: 3,
    name: '15D80',
    sheet_id_de: 5475,
    sheet_id_en: 5511,
    butane: 80.0,
    isobutane: 18.0,
    propane: 2.0,
    bar: 1.5
  },
  {
    id: 4,
    name: '16C',
    sheet_id_de: 5502,
    sheet_id_en: 5564,
    butane: 48.0,
    isobutane: 52.0,
    propane: 0.0,
    bar: 1.6
  },
  {
    id: 5,
    name: '18B',
    sheet_id_de: 5471,
    sheet_id_en: 5558,
    butane: 90.9,
    isobutane: 0.0,
    propane: 9.1,
    bar: 1.8
  },
  {
    id: 6,
    name: '18C',
    sheet_id_de: 5503,
    sheet_id_en: 5563,
    butane: 33.3,
    isobutane: 66.7,
    propane: 0.0,
    bar: 1.8
  },
  {
    id: 7,
    name: '20C',
    sheet_id_de: 5504,
    sheet_id_en: 5565,
    butane: 15.0,
    isobutane: 85.0,
    propane: 0.0,
    bar: 2.0
  },
  {
    id: 8,
    name: '20D53',
    sheet_id_de: 5483,
    sheet_id_en: 5527,
    butane: 53.0,
    isobutane: 42.0,
    propane: 5.0,
    bar: 2.0
  },
  {
    id: 9,
    name: '21',
    sheet_id_de: 4575,
    sheet_id_en: 4600,
    butane: 0.0,
    isobutane: 100.0,
    propane: 0.0,
    bar: 2.1
  },
  {
    id: 10,
    name: '21B',
    sheet_id_de: 5466,
    sheet_id_en: 5557,
    butane: 86.4,
    isobutane: 0.0,
    propane: 13.6,
    bar: 2.1
  },
  {
    id: 11,
    name: '24A',
    sheet_id_de: 5495,
    sheet_id_en: 5543,
    butane: 0.0,
    isobutane: 94.7,
    propane: 5.3,
    bar: 2.4
  },
  {
    id: 12,
    name: '24B',
    sheet_id_de: 5467,
    sheet_id_en: 5559,
    butane: 81.8,
    isobutane: 0.0,
    propane: 18.2,
    bar: 2.4
  },
  {
    id: 55,
    name: '24D65',
    sheet_id_de: 6117,
    sheet_id_en: 6118,
    butane: 65.0,
    isobutane: 19.0,
    propane: 16.0,
    bar: 2.4
  },
  {
    id: 13,
    name: '25A',
    sheet_id_de: 5491,
    sheet_id_en: 5538,
    butane: 0.0,
    isobutane: 93.0,
    propane: 7.0,
    bar: 2.5
  },
  {
    id: 14,
    name: '25B',
    sheet_id_de: 5463,
    sheet_id_en: 5552,
    butane: 80.3,
    isobutane: 0.0,
    propane: 19.7,
    bar: 2.5
  },
  {
    id: 15,
    name: '25D34',
    sheet_id_de: 5479,
    sheet_id_en: 5515,
    butane: 34.0,
    isobutane: 53.0,
    propane: 13.0,
    bar: 2.5
  },
  {
    id: 16,
    name: '25D55',
    sheet_id_de: 5481,
    sheet_id_en: 5517,
    butane: 55.0,
    isobutane: 28.6,
    propane: 16.4,
    bar: 2.5
  },
  {
    id: 17,
    name: '26A',
    sheet_id_de: 5498,
    sheet_id_en: 5546,
    butane: 0.0,
    isobutane: 91.2,
    propane: 8.8,
    bar: 2.6
  },
  {
    id: 18,
    name: '27A',
    sheet_id_de: 5492,
    sheet_id_en: 5539,
    butane: 0.0,
    isobutane: 89.5,
    propane: 10.5,
    bar: 2.7
  },
  {
    id: 19,
    name: '27B',
    sheet_id_de: 5462,
    sheet_id_en: 5553,
    butane: 77.3,
    isobutane: 0.0,
    propane: 22.7,
    bar: 2.7
  },
  {
    id: 20,
    name: '27D48',
    sheet_id_de: 5476,
    sheet_id_en: 5512,
    butane: 48.0,
    isobutane: 34.0,
    propane: 18.0,
    bar: 2.7
  },
  {
    id: 21,
    name: '27D60',
    sheet_id_de: 5477,
    sheet_id_en: 5513,
    butane: 60.0,
    isobutane: 20.0,
    propane: 20.0,
    bar: 2.7
  },
  {
    id: 22,
    name: '29D54',
    sheet_id_de: 5478,
    sheet_id_en: 5514,
    butane: 54.0,
    isobutane: 24.0,
    propane: 22.0,
    bar: 2.9
  },
  {
    id: 23,
    name: '30A',
    sheet_id_de: 5493,
    sheet_id_en: 5540,
    butane: 0.0,
    isobutane: 84.2,
    propane: 15.8,
    bar: 3.0
  },
  {
    id: 24,
    name: '30B',
    sheet_id_de: 5461,
    sheet_id_en: 5554,
    butane: 77.0,
    isobutane: 0.0,
    propane: 23.0,
    bar: 3.0
  },
  {
    id: 25,
    name: '32A',
    sheet_id_de: 6019,
    sheet_id_en: 5541,
    butane: 0.0,
    isobutane: 80.7,
    propane: 19.3,
    bar: 3.2
  },
  {
    id: 26,
    name: '32B',
    sheet_id_de: 5464,
    sheet_id_en: 5555,
    butane: 69.7,
    isobutane: 0.0,
    propane: 30.3,
    bar: 3.2
  },
  {
    id: 27,
    name: '32D06',
    sheet_id_de: 5484,
    sheet_id_en: 5528,
    butane: 6.0,
    isobutane: 75.0,
    propane: 19.0,
    bar: 3.2
  },
  {
    id: 28,
    name: '32D22',
    sheet_id_de: 5485,
    sheet_id_en: 5529,
    butane: 22.2,
    isobutane: 55.0,
    propane: 22.8,
    bar: 3.2
  },
  {
    id: 29,
    name: '32D54',
    sheet_id_de: 5480,
    sheet_id_en: 5519,
    butane: 54.0,
    isobutane: 20.0,
    propane: 26.0,
    bar: 3.2
  },
  {
    id: 30,
    name: '33D30',
    sheet_id_de: 5482,
    sheet_id_en: 5519,
    butane: 30.0,
    isobutane: 44.2,
    propane: 25.8,
    bar: 3.3
  },
  {
    id: 31,
    name: '34A',
    sheet_id_de: 5454,
    sheet_id_en: 5532,
    butane: 0.0,
    isobutane: 77.2,
    propane: 22.8,
    bar: 3.4
  },
  {
    id: 32,
    name: '35A',
    sheet_id_de: 5455,
    sheet_id_en: 5533,
    butane: 0.0,
    isobutane: 75.4,
    propane: 24.6,
    bar: 3.5
  },
  {
    id: 33,
    name: '35B',
    sheet_id_de: 5456,
    sheet_id_en: 5548,
    butane: 65.2,
    isobutane: 0.0,
    propane: 34.8,
    bar: 3.5
  },
  {
    id: 34,
    name: '35D04',
    sheet_id_de: 5486,
    sheet_id_en: 5530,
    butane: 4.0,
    isobutane: 72.0,
    propane: 24.0,
    bar: 3.5
  },
  {
    id: 35,
    name: '36A',
    sheet_id_de: 5499,
    sheet_id_en: 5547,
    butane: 0.0,
    isobutane: 73.7,
    propane: 26.3,
    bar: 3.6
  },
  {
    id: 36,
    name: '36B',
    sheet_id_de: 5470,
    sheet_id_en: 5561,
    butane: 63.6,
    isobutane: 0.0,
    propane: 36.4,
    bar: 3.6
  },
  {
    id: 37,
    name: '37A',
    sheet_id_de: 5496,
    sheet_id_en: 5544,
    butane: 0.0,
    isobutane: 71.9,
    propane: 28.1,
    bar: 3.7
  },
  {
    id: 38,
    name: '38A',
    sheet_id_de: 5472,
    sheet_id_en: 5534,
    butane: 0.0,
    isobutane: 70.2,
    propane: 29.8,
    bar: 3.8
  },
  {
    id: 39,
    name: '38B',
    sheet_id_de: 5469,
    sheet_id_en: 5560,
    butane: 60.6,
    isobutane: 0.0,
    propane: 39.4,
    bar: 3.8
  },
  {
    id: 40,
    name: '40A',
    sheet_id_de: 5488,
    sheet_id_en: 5535,
    butane: 0.0,
    isobutane: 66.7,
    propane: 33.3,
    bar: 4.0
  },
  {
    id: 41,
    name: '40B',
    sheet_id_de: 5457,
    sheet_id_en: 5549,
    butane: 57.6,
    isobutane: 0.0,
    propane: 42.4,
    bar: 4.0
  },
  {
    id: 42,
    name: '40D40',
    sheet_id_de: 5487,
    sheet_id_en: 5531,
    butane: 40.0,
    isobutane: 20.0,
    propane: 40.0,
    bar: 4.0
  },
  {
    id: 43,
    name: '41A',
    sheet_id_de: 5497,
    sheet_id_en: 5545,
    butane: 0.0,
    isobutane: 64.9,
    propane: 35.1,
    bar: 4.1
  },
  {
    id: 44,
    name: '41B',
    sheet_id_de: 5458,
    sheet_id_en: 6020,
    butane: 56.1,
    isobutane: 0.0,
    propane: 43.9,
    bar: 4.1
  },
  {
    id: 45,
    name: '42A',
    sheet_id_de: 5489,
    sheet_id_en: 5536,
    butane: 0.0,
    isobutane: 63.2,
    propane: 36.8,
    bar: 4.2
  },
  {
    id: 46,
    name: '42B',
    sheet_id_de: 5459,
    sheet_id_en: 5550,
    butane: 54.5,
    isobutane: 0.0,
    propane: 45.5,
    bar: 4.2
  },
  {
    id: 47,
    name: '42D30',
    sheet_id_de: 5474,
    sheet_id_en: 5510,
    butane: 30.0,
    isobutane: 28.4,
    propane: 41.6,
    bar: 4.2
  },
  {
    id: 48,
    name: '45A',
    sheet_id_de: 5490,
    sheet_id_en: 5537,
    butane: 0.0,
    isobutane: 57.9,
    propane: 42.1,
    bar: 4.5
  },
  {
    id: 49,
    name: '45B',
    sheet_id_de: 5460,
    sheet_id_en: 5551,
    butane: 50.0,
    isobutane: 0.0,
    propane: 50.0,
    bar: 4.5
  },
  {
    id: 50,
    name: '46B',
    sheet_id_de: 5465,
    sheet_id_en: 5556,
    butane: 48.5,
    isobutane: 0.0,
    propane: 51.5,
    bar: 4.6
  },
  {
    id: 51,
    name: '48D35',
    sheet_id_de: 5473,
    sheet_id_en: 5509,
    butane: 35.0,
    isobutane: 12.0,
    propane: 53.0,
    bar: 4.8
  },
  {
    id: 52,
    name: '50A',
    sheet_id_de: 5500,
    sheet_id_en: 5542,
    butane: 0.0,
    isobutane: 49.1,
    propane: 50.9,
    bar: 5.0
  },
  {
    id: 53,
    name: '55A',
    sheet_id_de: 6021,
    sheet_id_en: 6022,
    butane: 0.0,
    isobutane: 40.0,
    propane: 60.0,
    bar: 5.5
  },
  {
    id: 54,
    name: '78',
    sheet_id_de: 4576,
    sheet_id_en: 4601,
    butane: 0.0,
    isobutane: 0.0,
    propane: 100.0,
    bar: 7.8
  }
]
